import { message } from "antd";
import { AxiosWithoutHeader, BASE_URL } from "../../constant";
import {
  CREATE_DONER_FAIL,
  CREATE_DONER_PROCESSING,
  CREATE_DONER_SUCCESS,
  GET_DISTRICT_FAIL,
  GET_DISTRICT_PROCESSING,
  GET_DISTRICT_SUCCESS,
  GET_DONER_FAIL,
  GET_DONER_PROCESSING,
  GET_DONER_SUCCESS,
  GET_PROVINCE_FAIL,
  GET_PROVINCE_PROCESSING,
  GET_PROVINCE_SUCCESS,
} from "../../types";

export const getAllProvince = () => (dispatch) => {
  dispatch({
    type: GET_PROVINCE_PROCESSING,
  });

  return AxiosWithoutHeader.get(BASE_URL + "/doners/provinces")
    .then(({ status, data }) => {
      if (status === 200) {
        dispatch({
          type: GET_PROVINCE_SUCCESS,
          payload: data ? data : [],
        });
      } else {
        dispatch(dispatch, data.message, GET_PROVINCE_FAIL);
      }
    })
    .catch(() => {
      dispatch({
        type: GET_PROVINCE_FAIL,
        payload: "failed",
      });
    });
};

export const getAllDistrict = (provinceId) => (dispatch) => {
  dispatch({
    type: GET_DISTRICT_PROCESSING,
  });

  return AxiosWithoutHeader.get(BASE_URL + "/doners/district/" + provinceId)
    .then(({ status, data }) => {
      if (status === 200) {
        dispatch({
          type: GET_DISTRICT_SUCCESS,
          payload: data ? data : [],
        });
      } else {
        dispatch(dispatch, data.message, GET_DISTRICT_FAIL);
      }
    })
    .catch(() => {
      dispatch({
        type: GET_DISTRICT_FAIL,
        payload: "failed",
      });
    });
};

export const createDonerAction = (downerDetail) => (dispatch) => {
  dispatch({
    type: CREATE_DONER_PROCESSING,
  });

  const url = BASE_URL + "/doners";

  return AxiosWithoutHeader.post(url, downerDetail)
    .then(({ status, data }) => {
      if (data !== []) {
        message.success("Doner created successfully.");
        dispatch({
          type: CREATE_DONER_SUCCESS,
          payload: data,
        });

        dispatch(getAllDoner());
        window.location.href = "/";
      } else {
        message.warn("Doner failed to create.");
        dispatch({
          type: CREATE_DONER_FAIL,
          payload: "Doner failed to create.",
        });
      }
    })
    .catch(() => {
      message.warn("Doner failed to create.");
      dispatch({
        type: CREATE_DONER_FAIL,
        payload: "Doner failed to create.",
      });
    });
};

export const getAllDoner = (province, district, bloodGroup) => (dispatch) => {
  dispatch({
    type: GET_DONER_PROCESSING,
  });

  // let URL = "";
  // if (province !== "" && district === "") {
  //   URL = `${BASE_URL}/doners?province=${province}&sortBy=createdAt:desc&limit=100`;
  // } else if (province === "" && district !== "") {
  //   URL = `${BASE_URL}/doners?district=${district}&sortBy=createdAt:desc&limit=100`;
  // } else if (province !== "" && district !== "") {
  //   URL = `${BASE_URL}/doners?province=${province}&district=${district}&sortBy=createdAt:desc&limit=100`;
  // } else {
  //   URL = `${BASE_URL}/doners?sortBy=createdAt:desc&limit=100`;
  // }

  const params = new URLSearchParams();

  if (province !== "") {
    params.append("province", province);
  }
  if (district !== "") {
    params.append("district", district);
  }
  if (bloodGroup !== "") {
    params.append("bloodGroup", bloodGroup);
  }

  params.append("sortBy", "createdAt:desc");
  params.append("limit", "100");
  params.append("noRegex", "bloodGroup");

  const URL = `${BASE_URL}/doners?${params.toString()}`;

  console.log(province, district, bloodGroup);
  console.log(URL);
  

  return AxiosWithoutHeader.get(URL)
    .then(({ status, data }) => {
      if (status === 200) {
        dispatch({
          type: GET_DONER_SUCCESS,
          payload: data ? data : [],
        });
      } else {
        dispatch(dispatch, data.message, GET_DISTRICT_FAIL);
      }
    })
    .catch(() => {
      dispatch({
        type: GET_DONER_FAIL,
        payload: "failed",
      });
    });
};
